export const disabledIron = (
  selectedRank: string,
  selectedDivision: string
) => {
  return selectedRank === "Bronze" ||
    (selectedRank === "Iron" && selectedDivision === "3") ||
    selectedRank === "Silver" ||
    selectedRank === "Gold" ||
    selectedRank === "Platinum" ||
    selectedRank === "Diamond" ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl "
    : "cursor-pointer";
};

export const disabledBronze = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "Bronze" && selectedDivision === "3") ||
    selectedRank === "Silver" ||
    selectedRank === "Gold" ||
    selectedRank === "Platinum" ||
    selectedRank === "Diamond" ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};
export const disabledSilver = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "Silver" && selectedDivision === "3") ||
    selectedRank === "Gold" ||
    selectedRank === "Platinum" ||
    selectedRank === "Diamond" ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};

export const disabledGold = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "Gold" && selectedDivision === "3") ||
    selectedRank === "Platinum" ||
    selectedRank === "Diamond" ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};
export const disabledPlatinum = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "Platinum" && selectedDivision === "3") ||
    selectedRank === "Diamond" ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};
export const disabledDiamond = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "DiamondF" && selectedDivision === "3") ||
    selectedRank === "Ascendant" ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};
export const disabledAscendant = (
  selectedRank: string,
  selectedDivision: string
) => {
  return (selectedRank === "Ascendant" && selectedDivision === "3") ||
    selectedRank === "Immortal"
    ? "cursor-not-allowed bg-zinc-500/30  rounded-xl"
    : "cursor-pointer";
};
